import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getAbbreviated } from '@utils';

const SubjectDetailHeader = ({
  isNew,
  subjectType,
  subjectId,
  name,
  embeddedView,
  onClose,
}) => (
  <Container>
    {!isNew && (
      <NameContainer>
        <Initials>{getAbbreviated(name).substring(0, 3)}</Initials>
        <span>
          {' '}
          {subjectId} | {name}
        </span>
      </NameContainer>
    )}
    <MarkContainer>{isNew ? `NEW ${subjectType}` : subjectType}</MarkContainer>
    {!embeddedView && (
      <IconContainer>
        <a onClick={() => onClose()}>
          <i className="icon fa-times" />
        </a>
      </IconContainer>
    )}
  </Container>
);

SubjectDetailHeader.propTypes = {
  embeddedView: PropTypes.bool,
  isNew: PropTypes.bool,
  name: PropTypes.string.isRequired,
  subjectId: PropTypes.number.isRequired,
  subjectType: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

const Container = styled.div`
  background: #36449d;
  color: white;
  padding: 5px 12px 5px 12px;
  position: relative;
  height: 60px;

  span {
    &.label {
      opacity: 0.7;
    }

    &.value {
      margin-right: 10px;
    }
  }
`;

const NameContainer = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 10px;
`;

const Initials = styled.span`
  background: white;
  color: #36449d;
  width: 40px;
  height: 40px;
  display: inline-block;
  text-align: center;
  line-height: 40px;
  border-radius: 50%;
  font-weight: bold;
  font-size: 15px;
  margin-right: 15px;
`;

const MarkContainer = styled.p`
  position: absolute;
  right: 15px;
  top: 25px;
  font-size: 28px;
  line-height: 14px;
  font-weight: bold;
  opacity: 0.2;
  margin: 0;
  text-transform: uppercase;
`;

const IconContainer = styled.div`
  position: absolute;
  right: 6px;
  top: 3px;
`;

export default SubjectDetailHeader;
